import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { closeNotification } from 'client/modules/common/redux/actions/status-notification';
import formatMessage from '../utils/format-message';
import styles from './failure-notification-style.css';
import Notification from '../Notification';

/** @deprecated */
class FailureNotification extends Component {
  handleCloseNotification = () => {
    this.props.closeNotification();
  };

  render() {
    const { open, message, isMessageHtml, autoDisappear } = this.props;
    const failureMessage = formatMessage(message, isMessageHtml);
    return (
      <div
        style={{
          position: 'fixed',
          width: '98%',
          left: '0',
          top: '0',
          zIndex: '1200',
        }}
      >
        <Notification
          notificationType="failure"
          open={open}
          message={failureMessage}
          autoDisappear={autoDisappear}
          handleCloseNotification={this.handleCloseNotification}
          notificationStyles={`${styles.failureNotification}`}
        />
      </div>
    );
  }
}

FailureNotification.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string,
  closeNotification: PropTypes.func.isRequired,
  autoDisappear: PropTypes.bool,
  isMessageHtml: PropTypes.bool,
};

FailureNotification.defaultProps = {
  open: false,
  message: '',
  autoDisappear: true,
  isMessageHtml: false,
};

function mapStateToProps({ common }) {
  return {
    open: common.statusNotification.failure.open,
    message: common.statusNotification.failure.message,
    autoDisappear: common.statusNotification.autoDisappear,
    isMessageHtml: common.statusNotification.isMessageHtml,
  };
}

/** @deprecated */
export default connect(mapStateToProps, { closeNotification })(
  FailureNotification
);
